<template>
  <!--  -->
  <div class="spinner">
    <div class="spinner-a" :style="{ 'background-color': color || false }"></div>
    <div class="spinner-b" :style="{ 'background-color': color || false }"></div>
    <div class="spinner-c" :style="{ 'background-color': color || false }"></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    color: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/spinners';

.spinner {
  @include pulse-spinner();
}
</style>
